var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolderIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.922 0H1.98C1.45644 0.00211727 0.955081 0.211722 0.585805 0.582872C0.21653 0.954022 0.00946632 1.45644 0.00999999 1.98L0 13.863C0.00158264 14.3876 0.210697 14.8903 0.581677 15.2613C0.952657 15.6323 1.45536 15.8414 1.98 15.843H17.824C18.3486 15.8414 18.8513 15.6323 19.2223 15.2613C19.5933 14.8903 19.8024 14.3876 19.804 13.863V3.963C19.8024 3.43836 19.5933 2.93566 19.2223 2.56468C18.8513 2.1937 18.3486 1.98458 17.824 1.983H9.9L7.922 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIco);
export default __webpack_public_path__ + "static/media/folder-ico.e948a2e2ac89b8bef42dbe8a4c3d636b.svg";
export { ForwardRef as ReactComponent };